import { memo } from 'react';
import { Autocomplete } from '@mui/material';
import type { IAutoCompleteControlProps } from '../../../types/IComponentTypes';

/**
 * This component renders Autocomplete component to select values
 * @prop {value} is the curent entered value in the autocompelte filed
 * @prop {options} is the option list for filter
 * @prop {disabled} is the attribute to disable/enable the Autocomplete filed
 * @prop {id} is the unique id for identify the element
 * @prop {multiple} is to allow the multipel selection
 * @prop {freeSolo} is the
 * @prop {clearOnBlur} is to clear the value on blue
 * @prop {renderInput} is show the value in the auto compelte
 * @prop {className} is to add the css
 * @prop {onInputChange} is the event called on canges
 * @prop {groupBy} is the callback funcion containing with html
 * @prop {getOptionLabel} is the callback funcion containing with html
 * @prop {renderGroup} is the callback funcion containing with html
 * @prop {PopperComponent} is to add a popup for the list
 * @prop {handleChange} call back on change
 * @returns {JSX.Element} a  Autocomplete component.
 */

const AutoCompleteControl = ({
  value,
  options,
  disabled,
  id,
  multiple,
  freeSolo,
  clearOnBlur,
  renderInput,
  className,
  onInputChange,
  groupBy,
  getOptionLabel,
  renderGroup,
  PopperComponent,
  handleChange,
}: IAutoCompleteControlProps) => {
  return (
    <Autocomplete
      clearOnBlur={clearOnBlur}
      freeSolo={freeSolo}
      multiple={multiple}
      value={value}
      id={id}
      options={(options ?? []) as any}
      sx={{ m: 1, width: 165 }}
      disabled={disabled}
      renderInput={renderInput}
      onChange={(_, newValue) => handleChange(newValue as string)}
      className={className}
      onInputChange={onInputChange}
      groupBy={groupBy}
      getOptionLabel={
        getOptionLabel
          ? (option) => {
              if (typeof option === 'string') return option;
              return getOptionLabel(option);
            }
          : undefined
      }
      renderGroup={renderGroup}
      slots={{
        popper: PopperComponent,
      }}
    />
  );
};

export default memo(AutoCompleteControl);
